"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFloorPrice = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const live_env_1 = require("@ledgerhq/live-env");
const FLOOR_PRICE_CURRENCIES = new Set(["ethereum"]);
const getFloorPrice = (nft, currency) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!FLOOR_PRICE_CURRENCIES.has(nft.currencyId)) {
        return null;
    }
    try {
        const { data } = yield (0, network_1.default)({
            method: "GET",
            url: `${(0, live_env_1.getEnv)("NFT_ETH_METADATA_SERVICE")}/v1/marketdata/${nft.currencyId}/${(_a = currency === null || currency === void 0 ? void 0 : currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.chainId}/contract/${nft.contract}/floor-price`,
        });
        return data;
    }
    catch (err) {
        return null;
    }
});
exports.getFloorPrice = getFloorPrice;
//# sourceMappingURL=hook.js.map